import {makeAutoObservable} from 'mobx';

import type {AccountApiModel} from '../../../../api/account';

export class AccountModel {
  account: AccountApiModel;

  constructor(account: AccountApiModel) {
    this.account = account;

    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  get isPrimary() {
    return this.account.primary;
  }

  get type() {
    return this.account.type;
  }

  get value() {
    return this.account.value;
  }
}
